export default {
      id: "sun-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#sun",
      toString: function () {
        return this.url;
      }
    }